<template>
 <div style="flex:1 0 auto;position:relative;" v-if="canRender">
    <v-card class="ma-2 maincontent" >      
      <v-card-title style="flex-direction:column;align-items:stretch;height:100%;">
        <h2 class="mb-3" style="flex:0 0 auto;">{{$t('Admin.Nmea.FullTitle')}}</h2>                              
         <v-layout row wrap style="flex:1 0;overflow:auto;align-items:flex-start;" >
          <v-flex class="inline-block px-2">      
            <strong>{{$t("Admin.Nmea.AvailableNmea")}}</strong>
            <div class="panel mb-2">              
              <draggable v-model="nmeasConfig.rowHidden" v-bind="dragOptions" style="height:100%">  
                <v-chip small v-for="nmeaConfig in nmeasConfig.rowHidden" :key="nmeaConfig.name">
                  <v-icon class="ml-0 mr-2 pointer-move move-nmea" small style="flex-grow:0!important" left>mdi-cursor-move</v-icon>
                  {{nmeaConfig.name}}
                </v-chip>
              </draggable>
            </div>    
            <strong>{{$t("Admin.Nmea.NmeaPreLoaded")}}</strong>
            <div class="panel row mb-2 loaded">
              <draggable v-model="nmeasConfig.rowInit" v-bind="dragOptions" style="height:100%">                                     
                <admin-nmea-fields :fields="dicNmeaField[nmeaConfig.name]" :config="nmeaConfig" v-for="nmeaConfig in nmeasConfig.rowInit" :key="nmeaConfig.name" />              
              </draggable>
            </div>  
            <strong>{{$t("Admin.Nmea.NmeaLazyLoaded")}}</strong>
            <div class="panel row lazy">
              <draggable v-model="nmeasConfig.rowLazy" v-bind="dragOptions" style="height:100%">                                     
                <admin-nmea-fields :fields="dicNmeaField[nmeaConfig.name]" :config="nmeaConfig" v-for="nmeaConfig in nmeasConfig.rowLazy" :key="nmeaConfig.name" />              
              </draggable>
            </div>
          </v-flex>                         
        </v-layout>  
        <v-layout class="pt-2 adm-button" row wrap >          
          <v-btn :disabled="loading || !modified" @click.prevent="annuler">{{$t('Admin.Cancel')}}<v-icon right>mdi-restore</v-icon></v-btn>
          <v-btn :disabled="loading || !modified" @click.prevent="sauvegarde">{{$t('Admin.Save')}}<v-icon right>mdi-content-save</v-icon></v-btn>
        </v-layout>          
      </v-card-title>          
    </v-card> 
    <!-- Dialog de chargement... -->   
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300">
      <v-card color="primary" dark >
        <v-card-text>          
          {{status}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import draggable from 'vuedraggable'
import Component from 'vue-class-component'
import { Watch} from 'vue-property-decorator'
import { AloDbBase } from '@/models/alodb/AloDbBase'
import camelCase from 'lodash.camelcase'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import { DataPoolGlobalKeys } from '@/enum/DataPool'
import { AloDataPoolItem } from '@/models/alo/AloDataPoolItem'
import { NmeasConfig } from '@/models/datapool/NmeasConfig'

import {GliderCmd} from '@/models/datapool/GliderCmd'
import { directQuery } from '@/utils/api'
import apiMission from '@/api/mission'
import AdminNmeaFields from '@/components/admin/nmea/AdminNmeaFields.vue'
import { SecurityItemsKeys } from '@/enum/SecurityItems'


@Component({
  name: 'AdminNmea',
  components:{AdminNmeaFields,draggable}
})
export default class AdminNmea extends Vue {      
    
  loading = false
  canRender = true
  status = ""
  nmeasConfig = new NmeasConfig()
  dicNmeaField:{[index:string]:Array<string>} = {}

  created() {                            
    if(!this.$store.myGetters.userSecurity[SecurityItemsKeys.ADMIN_NMEA_DISPLAY].enable) {
      this.canRender = false       
      this.$router.push('/')
    }     
  }


  get nmeaList()  {
    return Object.keys(this.dicNmeaField)
  }

  get originalNmeaConfigStr() {
    const list = (this.$store.myGetters.dataPoolItemsValueByKey(DataPoolGlobalKeys['global.config.nmea']) as string | null || "").split('\n').filter(t => t && t.length > 0).sort()    
    return  list.join('\n')
  }

  get modified() {
    return JSON.stringify(this.nmeasConfig) != this.originalNmeaConfigStr
  }

  get dragOptions() {
      return {
        animation: 0,
        group: `nmea`,
        disabled:false,
        handle:'.move-nmea',
        ghostClass: "ghost"
      }
   }


  mounted(){
    this.loading = true
    directQuery(apiMission.getNmeaInfos).then((dic)=>{
      this.dicNmeaField = dic            
      this.dicNmeaField["seamrs"]?.push("YOS_CYCLE")
      this.dicNmeaField["computed"] = ["distance","flight_time","cog","sog","drift","mission_duration"]
      this.status = this.$t('Admin.Nmea.Loading').toString()
      this.$store.myActions.DATAPOOL_ENSURE({fullKey:DataPoolGlobalKeys['global.config.nmea']}).then(()=>{
        this.annuler()
        this.status = this.$t('Admin.Nmea.Loaded').toString()
      }).finally(()=>{
        this.loading = false;
      });    
    }).catch(()=>{
      this.status = this.$t('Admin.Nmea.Error').toString()
      this.loading = false
    })
  }
  

  /*Fonctions*/  
  sauvegarde() {
    //@ts-ignore
    this.status = this.$t('Admin.Nmea.Loading').toString()
    this.loading = true
    this.$store.myActions.DATAPOOL_UPDATE_REQUEST(
        new AloDataPoolItem({
        dtaValue:JSON.stringify(this.nmeasConfig),
        dtaKey:DataPoolGlobalKeys['global.config.nmea']
      })).then((data)=>{
        this.status = this.$t('Admin.Nmea.Loaded').toString()
        this.annuler()
      }).finally(()=>{
        this.loading = false
      })      
  }
  
  annuler() {        
    this.nmeasConfig = NmeasConfig.createNmeasConfig(this.originalNmeaConfigStr,this.nmeaList)    
  }

}
</script>
<style scoped>
.panel{
  border: 1px solid #ddd;
}
.row{  
  min-height: 100px;
}
</style>
<style>
.ghost {
  opacity: 0.7;
  background: #c8ebfb;
}
</style>